import { useMaasOidcLogout } from '@maas-tools/auth-oidc'
import { IdmEvents, IdmEventsMap } from 'common/idm/events'

export const useLogout = () => {
  const logoutOidc = useMaasOidcLogout()

  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  const handleLogout = async (urlToRedirect: string = '') => {
    window.postMessage('shell:logout', window.location.origin)
    IdmEvents.emit(IdmEventsMap.USER.LOGGED_OUT)
    sessionStorage.removeItem('maas-tenantId')
    logoutOidc().then(() => {
      if (urlToRedirect !== '') {
        window.location.replace(urlToRedirect)
      }
    })
  }

  return handleLogout
}
